import React, { useState, useEffect, useCallback } from 'react';
import '../styles/ScrollButtons.css';

const ScrollButtons = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showScrollBottom, setShowScrollBottom] = useState(false);
  const [lastScrollPosition, setLastScrollPosition] = useState(0);

  const checkScrollPosition = useCallback(() => {
    const currentPosition = window.pageYOffset;
    const isAtBottom = window.innerHeight + currentPosition >= document.body.offsetHeight - 50;
    if (currentPosition > lastScrollPosition && !isAtBottom) {
      setShowScrollBottom(true);
      setShowScrollTop(false);
    } else if (currentPosition < lastScrollPosition && currentPosition > 0) {
      setShowScrollTop(true);
      setShowScrollBottom(false);
    } else if (currentPosition === 0) {
      setShowScrollTop(false);
    } else if (isAtBottom) {
      setShowScrollBottom(false);
    }
    setLastScrollPosition(currentPosition);
  }, [lastScrollPosition]);

  useEffect(() => {
    window.addEventListener('scroll', checkScrollPosition);
    return () => window.removeEventListener('scroll', checkScrollPosition);
  }, [checkScrollPosition]);

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  const scrollToBottom = useCallback(() => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  }, []);

  return (
    <>
      {showScrollTop && (
        <button 
          className="scroll-button scroll-top"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          ↑
        </button>
      )}
      
      {showScrollBottom && (
        <button 
          className="scroll-button scroll-bottom"
          onClick={scrollToBottom}
          aria-label="Scroll to bottom"
        >
          ↓
        </button>
      )}
    </>
  );
};

export default ScrollButtons;